import { Component, Fragment, h, Prop, Element } from '@stencil/core';
import { initShadowMountPoints } from '../../../utils/utils';
import { PaymentMethod, RtrError } from '../../../redux/types';
import { ErrorType, hasError } from '../../rtr-errors/utils';
import { PaymentOption } from '../utils/types';

@Component({
  tag: 'rtr-payment-method-order',
  styleUrl: '../style.sass',
  shadow: true,
})
export class RtrPaymentMethodOrder {
  @Prop() currentMethod: PaymentMethod;
  @Prop() onSepaNameChange;
  @Prop() onBlikCodeChange;
  @Prop() showPaymentOptions;
  @Prop() errors: RtrError[] = [];

  @Element() methodEl: HTMLElement;
  private refEl: HTMLElement;

  componentDidLoad() {
    initShadowMountPoints(this.methodEl, 'stripe-sepa-iban');
    initShadowMountPoints(this.methodEl, 'stripe-cc-cardNumber');
    initShadowMountPoints(this.methodEl, 'stripe-cc-cardExpiry');
    initShadowMountPoints(this.methodEl, 'stripe-cc-cardCvc');
    initShadowMountPoints(this.methodEl, 'paypal-plus');
  }

  componentDidUpdate() {
    if (this.methodsHasError) {
      this.refEl?.scrollIntoView({ behavior: 'smooth' });
    }
  }

  get methodsHasError(): boolean {
    return hasError({ type: ErrorType.PaymentProblemWithMethod, errors: this.errors });
  }

  render() {
    if (this.showPaymentOptions) {
      return false;
    }

    return (
      <div class="RTPOptionsContainer" ref={el => (this.refEl = el)}>
        {this.currentMethod?.value === PaymentOption.StripeCC && (
          <Fragment>
            <rentware-spacer size="L" />

            <div class="RTPTitle">Credit card details</div>

            <rentware-spacer size="S" />

            <div class="RTPItemContainerOrder">
              <slot name="stripe-cc-cardNumber" />
            </div>
            <div class="RTPItemContainerOrder">
              <slot name="stripe-cc-cardExpiry" />
            </div>
            <div class="RTPItemContainerOrder">
              <slot name="stripe-cc-cardCvc" />
            </div>
          </Fragment>
        )}

        {this.currentMethod?.value === PaymentOption.PayPalPlus && <slot name="paypal-plus" />}

        {this.currentMethod?.value === PaymentOption.StripeSepa && (
          <Fragment>
            <rentware-spacer size="L" />

            <div class="RTPTitle">SEPA details</div>

            <rentware-spacer size="S" />

            <div class="RTPItemContainerOrder">
              <input
                class="RTPInputSEPA"
                id="account-holder-name"
                name="account-holder-name"
                placeholder="Name"
                required
                onInput={(event: Event) => this.onSepaNameChange((event.target as any).value)}
              />
            </div>

            <div class="RTPItemContainerOrder">
              <slot name="stripe-sepa-iban" />
            </div>
          </Fragment>
        )}

          {this.currentMethod?.value === PaymentOption.StripeBlik && (
              <rtr-payment-blik onChange={this.onBlikCodeChange}/>
          )}
      </div>
    );
  }
}
